import {
    Card,
    CardContent,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { CostFrequencyModifierRow } from "./cost-frequency-modifier-row"

export function CostFrequencyModifiersSection({ costResult }) {
    const impacts = (costResult?.ruleSetImpact || []).filter(isFrequencyImpact)
    const totalDeltaOccurrences = costResult?.totalFrequencyDeltaOccurrences || 0

    return (
        <If value={impacts.length > 0}>
            <Card data-cy="frequency-modifiers-section">
                <CardContent sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <Stack direction="row" justifyContent="space-between" alignItems="baseline">
                            <Typography variant="h6">Frequency modifiers</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {formatDeltaLabel(totalDeltaOccurrences)}
                            </Typography>
                        </Stack>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Rule</TableCell>
                                        <TableCell align="right">Matched tasks</TableCell>
                                        <TableCell align="right">Multiplier</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <Repeat list={impacts} item={<CostFrequencyModifierRow />} />
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                </CardContent>
            </Card>
        </If>
    )
}

function isFrequencyImpact(impact) {
    return impact?.action === "frequencyModifier" || impact?.frequencyMultiplier != null
}

function formatDeltaLabel(occurrences) {
    if (!Number.isFinite(occurrences) || occurrences === 0) return ""
    const sign = occurrences >= 0 ? "+" : ""
    return `${sign}${Math.round(occurrences)} visits/year total`
}
